import { registerHandler } from '@/utils/queues/pc-queues'

export const registerHandlerElementLeadGen = (): void => {
  registerHandler('element.leadGen', function () {
    import(/* webpackChunkName: '@/lead-gen/app' */ '@/lead-gen/app')
  })
}
